/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessTokenDetails } from '../models/AccessTokenDetails';
import type { AccessTokenRefresh } from '../models/AccessTokenRefresh';
import type { UserLogin } from '../models/UserLogin';
import { request as __request } from '../core/request';

export class AccessTokenVService {

    /**
     * @param requestBody
     * @returns AccessTokenDetails OK
     * @throws ApiError
     */
    public static async accessTokenVCreateAccessToken(
        requestBody?: UserLogin,
    ): Promise<AccessTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/Auth/AccessToken`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AccessTokenDetails OK
     * @throws ApiError
     */
    public static async accessTokenVRefreshAccessToken(
        requestBody?: AccessTokenRefresh,
    ): Promise<AccessTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/Auth/RefreshToken`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

}